import {Accordion, AccordionDetails, Box, styled} from '@mui/material';

export const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
	padding: 0;
`;

export const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 16px;
	border-radius: 8px;
`;

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
